import { useState } from "react";
import { Link, useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import CombinedShapeMask from "@/components/CombinedShapeMask";
import VideoOverlay from "@/components/video-overlay";

export default function ThankYou() {
  const [showVideo, setShowVideo] = useState(false);
  const [, setLocation] = useLocation();
  const PLAYBACK_ID = 'nHZrtzd3BAXRzV00OLoP02rJmXQKeb6Fn29S51hrn4gj8';

  const handlePlayVideo = () => {
    setShowVideo(true);
  };

  const handleClose = () => {
    setLocation('/');
  };

  return (
    <div className="fixed inset-0 bg-[#1c1815] bg-opacity-60 z-50 flex items-center justify-center p-2">
      <div className="flex flex-col items-start justify-start bg-[#fffcf5] w-full max-w-[1000px] h-[600px] relative">
        {/* Close Button */}
        <Button
          onClick={handleClose}
          variant="ghost"
          size="icon"
          className="absolute top-4 right-4 z-20 text-[#1c1815] hover:bg-[#f4eadf] hover:bg-opacity-50"
        >
          <X size={24} />
        </Button>

        <div className="flex flex-col md:flex-row md:space-x-8 items-center justify-center w-full h-full">
          {/* Left Column */}
          <div className="w-full md:w-[484px] h-[324px] md:h-full relative">
            <div className="inline-flex flex-col items-center justify-end h-full px-4 py-[60px]">
              <div className="relative w-full md:w-[483px] h-full">
                <CombinedShapeMask
                  splitPointPercent={56}
                  curveFactor={0.03}
                  controlPointYPercent={117}
                >
                  <img
                    src="/assets/video-placeholder-image.png"
                    alt="Video preview"
                    className="w-full h-full object-cover"
                  />
                </CombinedShapeMask>
                <div className="absolute left-0 bottom-0 bg-gradient-to-b from-[#1c1815] to-[#1c1815] w-full h-[184px]" />
              </div>
              <div className="flex flex-col space-y-1.5 items-start justify-start w-full md:w-[452px]">
                <p className="text-5xl font-serifbold leading-10 text-[#dfd968] uppercase">Why we're</p>
                <div className="inline-flex items-center justify-end w-full md:w-[452px]">
                  <p className="text-5xl font-serifbold leading-10 text-[#dfd968] uppercase">different</p>
                </div>
              </div>
            </div>
            {/* Play Button - Centered on mobile and desktop */}
            <Button
              onClick={handlePlayVideo}
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
                       bg-[#c39d63] hover:bg-[#b38d53] w-20 h-20 rounded-none z-10"
            >
              <img
                src="/assets/play-button.svg"
                alt="Play Video"
                className="w-[75px] h-[75px] object-contain"
              />
            </Button>
          </div>

          {/* Right Column */}
          <div className="flex flex-col space-y-14 items-start justify-start w-full md:w-[484px] h-full pl-4 pr-10 pt-16 pb-6">
            <div className="flex flex-col space-y-6 items-start justify-start w-full md:w-[428px]">
              <div className="opacity-50 w-[124.59px] h-[100px] relative">
                <img
                  src="/assets/upper-right-butterfly-logo.svg"
                  alt="Decorative Butterfly"
                  className="w-[124.59px] h-[100px] object-contain"
                />
              </div>
              <div className="flex flex-col space-y-4 items-start justify-center w-full md:w-[428px]">
                <p className="text-6xl font-serifbold leading-[50px] text-[#c39d63] uppercase">YOU'RE ON THE LIST!</p>
                <p className="text-sm font-sans tracking-[0.28px] leading-none text-[#1c1815]">
                  We're excited to have you on this journey, empowering you to understand and track your health privately and effortlessly.
                </p>
              </div>
            </div>
            <div className="flex flex-col space-y-4 items-start justify-start w-full md:w-[428px]">
              <p className="text-sm font-sans tracking-[0.28px] leading-none text-[#1c1815]">
                Invite your friends to join 28X!
              </p>
              <div className="inline-flex space-x-3 items-center justify-start">
                <Button size="icon" className="bg-[#573262] hover:bg-[#472251] w-8 h-8 p-1.5">
                  <img src="/assets/snapchat.svg" alt="Share on Snapchat" className="w-full h-full" />
                </Button>
                <Button size="icon" className="bg-[#573262] hover:bg-[#472251] w-8 h-8 p-1.5">
                  <img src="/assets/tiktok.svg" alt="Share on TikTok" className="w-full h-full" />
                </Button>
                <Button size="icon" className="bg-[#573262] hover:bg-[#472251] w-8 h-8 p-1.5">
                  <img src="/assets/whatsapp.svg" alt="Share on WhatsApp" className="w-full h-full" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showVideo && (
        <VideoOverlay
          playbackId={PLAYBACK_ID}
          onClose={() => setShowVideo(false)}
        />
      )}
    </div>
  );
}